declare global {
  interface Window {
    VITE_ENV: string;
    VITE_API_URL: string;
    VITE_BASE_API_URL: string;
    VITE_KEYCLOAK_REALM: string;
    VITE_KEYCLOAK_CLIENT_ID: string;
    VITE_KEYCLOAK_URL: string;
    VITE_KEYCLOAK_LOGINURL: string;
    VITE_KEYCLOAK_STATE: string;
    VITE_COMMON_APIURL: string;
    VITE_LOGIN_APIURL: string;
    VITE_MASTERS_APIURL: string;
    VITE_SHOW_APIURL: string;
    VITE_JOB_APIURL: string;
    VITE_USER_APIURL: string;  
    VITE_FINANCE_APIURL: string;  
    VITE_PAYMENTS_APIURL: string;
    VITE_TRAFFIC_APIURL: string;
    VITE_TEMPLATES_APIURL: string;
    VITE_DMS_APIURL: string;
   
    VITE_DMS_DOWNLOAD_APIURL:string;
  }
}

const baseUrl =  window.location.origin + '/';
export const ENV = {
 

  ENVIRONMENT: window.VITE_ENV ?? import.meta.env.VITE_ENV,
  API_URL: window.VITE_API_URL ?? import.meta.env.VITE_API_URL,

  BASE_API_URL: baseUrl,
  KEYCLOAK_REALM: window.VITE_KEYCLOAK_REALM ?? import.meta.env.VITE_KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID: window.VITE_KEYCLOAK_CLIENT_ID ?? import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  KEYCLOAK_LOGINURL: window.VITE_KEYCLOAK_LOGINURL ?? import.meta.env.VITE_KEYCLOAK_LOGINURL,
  KEYCLOAK_STATE: window.VITE_KEYCLOAK_STATE ?? import.meta.env.VITE_KEYCLOAK_STATE,

  KEYCLOAK_URL: window.VITE_KEYCLOAK_URL ?? import.meta.env.VITE_KEYCLOAK_URL,
  COMMON_APIURL: window.VITE_COMMON_APIURL ?? import.meta.env.VITE_COMMON_APIURL,
  LOGIN_APIURL: window.VITE_LOGIN_APIURL ?? import.meta.env.VITE_LOGIN_APIURL,
  MASTERS_APIURL: window.VITE_MASTERS_APIURL ?? import.meta.env.VITE_MASTERS_APIURL,
  SHOW_APIURL: window.VITE_SHOW_APIURL ?? import.meta.env.VITE_SHOW_APIURL,
  JOB_APIURL: window.VITE_JOB_APIURL ?? import.meta.env.VITE_JOB_APIURL,
  USER_APIURL: window.VITE_USER_APIURL ?? import.meta.env.VITE_USER_APIURL,
  FINANCE_APIURL: window.VITE_FINANCE_APIURL ?? import.meta.env.VITE_FINANCE_APIURL,
  PAYMENTS_APIURL: window.VITE_PAYMENTS_APIURL ?? import.meta.env.VITE_PAYMENTS_APIURL,
  TRAFFIC_APIURL: window.VITE_TRAFFIC_APIURL ?? import.meta.env.VITE_TRAFFIC_APIURL,
  TEMPLATES_APIURL: window.VITE_TEMPLATES_APIURL ?? import.meta.env.VITE_TEMPLATES_APIURL,
  DMS_APIURL: window.VITE_DMS_APIURL ?? import.meta.env.VITE_DMS_APIURL,
  
  DMS_DOWNLOAD_APIURL:window.VITE_DMS_DOWNLOAD_APIURL??import.meta.env.VITE_DMS_DOWNLOAD_APIURL,
};
